export const OPERATOR = {
    NONE: "",
    DESCENDANT: " ",
    CHILD: " > ",
};
export const CSS_SELECTOR_TYPE = {
    id: "id",
    class: "class",
    tag: "tag",
    attribute: "attribute",
    nthchild: "nthchild",
    nthoftype: "nthoftype",
};
//# sourceMappingURL=types.js.map